import { render, staticRenderFns } from "./PanelPrincipal.vue?vue&type=template&id=0468190c&"
import script from "./PanelPrincipal.vue?vue&type=script&lang=js&"
export * from "./PanelPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports